





















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";
import InstrumentSearchResultsTable, { InstrumentSearchResult } from "./InstrumentSearchResultsTable.vue";
import {
  InstrumentDetail, SelectedInstrument, DrivewealthAccountManagementType
} from "@/shared/types";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import Pagination from "@/shared/components/ui/Pagination.vue";

const maxTableRows = 10;

@Component({
  components: {
    Pagination,
    InstrumentSearchResultsTable
  }
})
export default class SweepInstrumentSearch extends Vue {

  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop({ required: false }) drivewealthAccountId: number;

  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  statusMap = drivewealth.statusMap;
  pageSize = 10;
  page = 1;
  searchTerm = null;

  mounted () {
    this.drivewealthStore.searchInstruments({ searchTermParam: "", accountId: this.drivewealthAccountId, pageNumber: this.page, pageSize: this.pageSize });
  }

  @Watch("searchTerm")
  onSearchTermChange (searchValue): void {
    this.debouncedSearch(searchValue, this.drivewealthAccountId, this.page, this.pageSize);
  }

  debouncedSearch = _.debounce(
      (s, a, n, z) => this.drivewealthStore.searchInstruments({ searchTermParam: s, accountId: a , pageNumber: n, pageSize: z}), 600);

  get noSearchResults () {
    return !!this.searchTerm && this.drivewealthStore.instrumentSearchIsLoaded &&
      this.drivewealthStore.instrumentSearchResults.length === 0;
  }

  get showBusyState () {
    return this.drivewealthStore.instrumentSearchIsLoading || this.noSearchResults;
  }

  switchPage (toPage): void {
    this.debouncedSearch(this.searchTerm, this.drivewealthAccountId, toPage, this.pageSize);
  }

  mapToSelectedInstrument (d: InstrumentDetail): SelectedInstrument {
    return {
      instrumentId: d.instrumentId,
      stockSymbol: d.stockSymbol,
      displaySymbol: null,
      companyName: d.companyName,
      website: d.website,
      imageUrl: d.imageUrl,
      status: d.status,
      currentPrice: d.currentPrice,
      allocation: 0,
      drivewealthAccountId: this.drivewealthAccountId ? this.drivewealthAccountId : 0,
      accountType: DrivewealthAccountManagementType.OpenBrokerage
    };
  }

  get detailItems (): InstrumentSearchResult[] {
    if (!this.drivewealthStore.instrumentSearchResults) {
      return [];
    }
    return this.drivewealthStore.instrumentSearchResults.slice(0, maxTableRows).map(d => ({
      instrument: { symbol: d.stockSymbol, companyName: d.companyName, website: d.website, imageUrl: d.imageUrl },
      isEtfOrEquity: this.drivewealthStore.isFundEtfOrEquity(d.fundType),
      status: this.statusMap[d.status],
      action: this.mapToSelectedInstrument(d),
    }));
  }
}
